import { useQuery } from "@tanstack/react-query";
import client from "../client";

// Subset of backend CommissionCharge that we render. Includes failed charges.
export interface CommissionChargeRow {
  id: string;
  billingMonth: number;
  billingYear: number;
  commissionAmount: number;
  totalAmount: number | null;
  status: "pending" | "charged" | "paid" | "failed" | "cancelled";
  failureReason: string | null;
  chargedAt: string | null;
  rechargeCount: number;
}

// Full charge history (newest first), incl. failed charges that never became a Stripe invoice.
export function useChargeHistory(userId: string) {
  return useQuery({
    queryKey: ["crm", "chargeHistory", userId],
    queryFn: () =>
      client
        .get<CommissionChargeRow[]>(
          `/admin/commission-billing/history/${userId}`,
        )
        .then((r) => r.data),
    enabled: Boolean(userId),
    staleTime: 5 * 60 * 1000,
  });
}
